import MauChungTuPage from "./MauChungTuPage";

export default MauChungTuPage;
